// User
export const USER_ROLE_LIST_SUCCESS = 'USER_ROLE_LIST_SUCCESS';
export const CREATE_USER_ROLE_SUCCESS_SUCCESS = 'CREATE_USER_ROLE_SUCCESS_SUCCESS';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const DELETE_USER_ROLE_SUCCESS = 'DELETE_USER_ROLE_SUCCESS';
export const REGENERATE_PASSWORD_USER_ROLE_SUCCESS = 'REGENERATE_PASSWORD_USER_ROLE_SUCCESS';
